import { INavigationRequest } from '@addins/core/map';
import { CallcardButtonTool } from './callcard-button-tool';

export class NavigateButtonTool extends CallcardButtonTool<INavigationRequest> {
  constructor(text: string, icon: string, position: number) {
    super(text, icon, position);
  }
  click() {}
}
